import { Loader2 } from 'lucide-react';

export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-navy-950 flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-accent-400/20 blur-xl animate-pulse"></div>
          <Loader2 className="h-12 w-12 animate-spin text-accent-400 mx-auto mb-4 relative" />
        </div>
        <p className="text-navy-300 font-medium">Carregando...</p>
      </div>
    </div>
  );
}
